// vendor
import { Module } from "vuex";
import Vue from "vue";
// project
import { Dictionary } from "@/utils/types";

type State = {
	storage:Dictionary<any>
}

export const Cache:Module<State, {}> = {
	namespaced:true,
	state: {
		storage:{}
	},
	getters: {
		getValue: (state) => (key:string) => {
			return state.storage[key];
		}
	},
	mutations:{
		setValue(state, payload:{ k:string, v:any }){
			Vue.set(state.storage, payload.k, payload.v);
		}
	}
}